// extracted by mini-css-extract-plugin
module.exports = {"container":"BookSearchItem_container__2dEKQ","content":"BookSearchItem_content__12UdU","title":"BookSearchItem_title__GDr9S","imageOuter":"BookSearchItem_imageOuter__1goxR"};